import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useGlobalFilterQuery } from '../../hooks/filter';
import { useStore } from '../../store';
import { FilterConfigDto } from '../../store/states/filterTypes';
import { FiltersComponent } from '../filter/FiltersComponent';

import styles from './navigation.module.scss';

type NavigationGlobalFiltersProps = {
  globalFilters?: FilterConfigDto[];
  rootPageId?: string;
  globalFilterResult: ReturnType<typeof useGlobalFilterQuery>;
};

export const NavigationGlobalFilters = ({
  globalFilters,
  rootPageId,
  globalFilterResult,
}: NavigationGlobalFiltersProps) => {
  const { t } = useTranslation();

  const visibleFilters = useMemo(
    () => (globalFilters ?? []).filter((filter) => !filter.hidden),
    [globalFilters]
  );

  const resetFilterSelections = useStore(
    (state) => state.resetFilterSelections
  );

  const { validatedData, error, isFetching } = globalFilterResult;

  if (rootPageId == null || visibleFilters.length === 0) {
    return undefined;
  }

  return (
    <div className={styles['global-filters']}>
      <FiltersComponent
        config={{ filters: visibleFilters }}
        entityId={rootPageId}
        error={error}
        disableDynamicWidth
        hideSelectAll
        isFetching={isFetching}
        resetFilterSelection={resetFilterSelections}
        translate={t}
        showFilterActions={false}
        validatedData={validatedData}
      />
    </div>
  );
};
